import Vue from 'vue';

Vue.directive("track-call", {
	inserted: function(el, binding) {
		let provider = binding.value;
		
		el.onclick = function() {
			// console.log(el);
			let event = "Call_" + el.id;
			analytics.track(event, {});
			goog_report_conversion(el.href, el.id);
		}
	}
})


// WEBPACK FOOTER //
// ./src/directives/track-call.js